import { getMinBetweenNextHourAndEndOfDay, now, toISO } from '@jooxter/utils';

export const defaultResourceFiltersRange = () => ({
  from: toISO(now()),
  to: toISO(getMinBetweenNextHourAndEndOfDay(now())),
});

export const defaultColleagueFiltersRange = () => ({
  from: toISO(now().startOf('week')),
  to: toISO(now().endOf('week').minus({ days: 2 })),
});
